import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import LocationsService from "../../services/locationsService";

// Queries
export const useGetLocation = (locationID, queryOptions = {}) => {
  return useQuery(
    ["locations", locationID],
    () => LocationsService.get(locationID),
    {
      enabled: locationID !== null && locationID !== undefined,
      ...queryOptions
    }
  );
};

export const useGetLocations = (queryOptions = {}) => {
  return useQuery(["locations"], () => LocationsService.index(), queryOptions);
};

// Mutations
export const useUpdateLocation = (locationID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (locationParams) => LocationsService.update(locationID, locationParams),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["locations", locationID], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};

export const useCreateLocation = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (locationParams) => LocationsService.create(locationParams),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["locations", data.id], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};

export const useDeleteLocation = (locationID, mutationOptions = {}) => {
  return useMutation(
    () => LocationsService.delete(locationID),
    mutationOptions
  );
};

export const useBulkDeleteLocations = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (locationIDs) => LocationsService.bulkDelete(locationIDs),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.setQueryData(["locations"], data);
        mutationOptions.onSuccess(data);
      },
    }
  );
};
